import { HTMLCustomElement, formatDuration } from '@emartech/ui-framework-utils';
import configStore from '../../utils/config-store';
import State from './state';

class EDuration extends HTMLCustomElement {
  init() {
    this._state = new State(this._render.bind(this));

    configStore.subscribe(this._configChangeCallback.bind(this));
  }

  connectedCallback() {
    this._state.setState({ _isConnected: true });
  }

  disconnectedCallback() {
    this._state.setState({ _isConnected: false });
  }

  static get observedAttributes() {
    return ['value', 'precision', 'pad', 'show-zero-parts'];
  }

  set value(value) {
    this._state.setState({ value: value === undefined ? null : value });
  }

  set precision(value) {
    this._state.setState({ precision: value === null ? 'seconds' : value });
  }

  set pad(value) {
    this._state.setState({ pad: super._convertAttributeToBoolean(value) });
  }

  set showZeroParts(value) {
    this._state.setState({ showZeroParts: super._convertAttributeToBoolean(value) });
  }

  _configChangeCallback() {
    this._state.setState({ language: configStore.config.language });
  }

  _render() {
    if (!this._state.state._isConnected) {
      return;
    }
    this.textContent = formatDuration(this._state.state.value, this._state.state);
  }
}

export default EDuration;
